import { useState } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Language } from '../lib/translations';

const LANGUAGES = [
  { code: 'en' as Language, label: 'English', flag: '🇺🇸' },
  { code: 'es' as Language, label: 'Español', flag: '🇪🇸' },
];

export function LanguageSelector() {
  const { language, setLanguage } = useLanguage();
  const [isOpen, setIsOpen] = useState(false);

  const currentLang = LANGUAGES.find(l => l.code === language) || LANGUAGES[0];

  const handleSelect = async (lang: Language) => {
    await setLanguage(lang);
    setIsOpen(false);
  };

  return (
    <div style={{ position: 'relative' }}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="btn btn-secondary"
        style={{ padding: '0.5rem 0.75rem', fontSize: '0.875rem' }}
      >
        {currentLang.flag} {currentLang.code.toUpperCase()}
      </button>

      {isOpen && (
        <div
          style={{
            position: 'absolute',
            top: '100%',
            right: 0,
            marginTop: '0.5rem',
            background: 'white',
            borderRadius: '12px',
            boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)',
            overflow: 'hidden',
            minWidth: '150px',
            zIndex: 100,
          }}
        >
          {LANGUAGES.map((lang) => (
            <button
              key={lang.code}
              onClick={() => handleSelect(lang.code)}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '0.75rem',
                width: '100%',
                padding: '0.75rem 1rem',
                border: 'none',
                background: language === lang.code ? '#f3f4f6' : 'white',
                cursor: 'pointer',
                textAlign: 'left',
                fontSize: '0.875rem',
              }}
            >
              <span style={{ fontSize: '1.25rem' }}>{lang.flag}</span>
              <span>{lang.label}</span>
              {language === lang.code && (
                <span style={{ marginLeft: 'auto', color: '#6366f1' }}>✓</span>
              )}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
